/* DARKNESS x TECHNOSTOFF — nur auf templates/collection.darkness.json + templates/product.darkness.json geladen. */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    /* Blitz-Toggle-Button aus der eigenen Section in die echte Produkt-Galerie
       verschieben (DOM-Move statt main-product.liquid anzufassen). */
    var mount = document.querySelector("[data-drk-blitz-mount]");
    var stage = document.querySelector("[data-drk-stage]");
    if (mount && stage) {
      stage.appendChild(mount);
    }
    var toggle = document.querySelector("[data-drk-blitz-toggle]");
    if (stage && toggle) {
      toggle.addEventListener("click", function () {
        var lit = stage.classList.toggle("is-lit");
        toggle.setAttribute("aria-pressed", lit ? "true" : "false");
      });
      document.addEventListener("keydown", function (e) {
        if (
          (e.key === "b" || e.key === "B") &&
          !e.metaKey && !e.ctrlKey && !e.altKey &&
          !/input|textarea|select/i.test(document.activeElement.tagName)
        ) {
          toggle.click();
        }
      });
    }
  });
})();
